export class Header {
    constructor() {
        this.eventHandlers();
        $(document.body).trigger('sticky_menu');
        $(document.body).trigger('menu_overlay');
        $(document.body).trigger('append_children');
    }

    eventHandlers() {
        $(document.body).on('click', "#signin-form-container li.menu-item-has-children", this.toggleSidebarChildren.bind(this));
        $(document.body).on('click', "#signin-form-container li.menu-item-has-children .sub-menu a", this.stopPropagation.bind(this));
        $(document.body).on("click", ".burger", this.toggleBurger.bind(this));
        $(document.body).on("click", "span.toggle-children", this.toggleMenuItem.bind(this));
        $(document.body).on("keydown", 'input[type=number]', this.disableKeydown.bind(this));
        $(document.body).on("focus", 'input[type=number]', this.disableScrollInNumberField.bind(this));

        //Methods
        $(document.body).on('sticky_menu', this.stickyMenu.bind(this));
        $(document.body).on('menu_overlay', this.menuOverlay.bind(this));
        $(document.body).on('append_children', this.appendChildren.bind(this));
    }

    disableScrollInNumberField(e) {
        const _this = $(e.currentTarget);
        _this.on('wheel.disableScroll', function (e) {
            e.preventDefault();
        });
    }

    stopPropagation(e) {
        e.stopPropagation();
    }

    //disable keydown on number field
    disableKeydown(e) {
        if (event.keyCode === 38 || event.keyCode === 40) {
            e.preventDefault();
        }
    }

    toggleSidebarChildren(e) {
        e.preventDefault();
        const _this = $(e.currentTarget);
        if (_this.hasClass('open')) {
            _this.removeClass('open');
            _this.find('.sub-menu').slideUp(100);
        } else {
            _this.addClass('open');
            _this.find('.sub-menu').slideDown(100);
        }
    }

    toggleBurger() {
        const body = $("body");
        const className = "menu-active";
        if (body.hasClass(className)) {
            body.removeClass(className);
        } else {
            body.addClass(className);
        }
    }

    stickyMenu() {
        let headerHeight = $('header').height();
        if ($('body.menu-scroll').length) return;
        $(window).on('scroll', function () {
            let scrollTop = $(window).scrollTop();
            if (scrollTop > headerHeight) {
                $("body").addClass("menu-scroll");
            } else {
                $("body").removeClass("menu-scroll");
            }
        });

        if ($(window).scrollTop() > headerHeight) {
            $("body").addClass("menu-scroll");
        } else {
            if (!$('.menu-active').length) {
                $("body").removeClass("menu-scroll");
            }
        }
    }

    toggleMenuItem(e) {
        e.preventDefault();
        const _this = $(e.currentTarget);
        _this.toggleClass("toggle-active");
        _this.parent("a").siblings("ul.sub-menu").slideToggle();
    }

    appendChildren() {
        $("li.menu-item-has-children").each(function () {
            $("> a", this).append('<span class="toggle-children"></span>')
        });
    }

    menuOverlay() {
        const menuItem = "header li.menu-item-has-children";
        $(menuItem).on('mouseenter', function () {
            $('body').addClass('menu-hovered');
        }).on('mouseleave', function () {
            $('body').removeClass('menu-hovered');
        });
    }
}